import React, { useEffect } from "react";
import "./LegalModal.scss";

const LegalModal = ({ isOpen, onClose }) => {
  // Prevent body scrolling while modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    // Remove when modal is closed
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isOpen]);

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("legal-modal")) {
      onClose();
    }
  };

  return (
    <div
      className={`legal-modal ${isOpen ? "open" : ""}`}
      onClick={handleOverlayClick}
    >
      <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Mentions Légales</h2>

        <section>
          <h3>Éditeur du site</h3>
          <p>
            Le présent site est édité par la société{" "}
            <strong>SBHM DIGITAL</strong>, société à responsabilité limitée
            (SARL) au capital de 1 000 euros, immatriculée au Registre du
            Commerce et des Sociétés de Toulouse sous le numéro 930 118 583
            R.C.S. Toulouse.
          </p>
          <p>
            Siège social :<br />
            510 Chemin de la Rivière,
            <br />
            31660 Bessières, France.
          </p>
          <p>
            Directeur de la publication :<br />
            Monsieur Samir Benbrahim, Gérant.
          </p>
          <p>
            Adresse e-mail :{" "}
            <a href="mailto:sbhm-concept@gmail.com">sbhm-concept@gmail.com</a>
            <br />
            Numéro de téléphone : [numéro à ajouter]
          </p>
        </section>

        <section>
          <h3>Hébergement du site</h3>
          <p>
            L’hébergement du site est assuré par <strong>OVH</strong>, dont le
            siège social est situé à l’adresse suivante :
          </p>
          <p>
            OVH SAS
            <br />
            2 rue Kellermann,
            <br />
            59100 Roubaix, France.
          </p>
          <p>
            Numéro de téléphone : +33 9 72 10 10 07
            <br />
            Site web :{" "}
            <a
              href="https://www.ovh.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.ovh.com
            </a>
          </p>
        </section>

        <section>
          <h3>Numéro de TVA intracommunautaire</h3>
          <p>
            Le numéro de TVA intracommunautaire de la société est : [Numéro à
            ajouter].
          </p>
        </section>

        <section>
          <h3>Propriété intellectuelle</h3>
          <p>
            Tous les éléments présents sur le site, y compris les textes,
            images, graphismes, et logos, sont protégés par les lois en vigueur
            sur la propriété intellectuelle. Bien que certaines images
            n’appartiennent pas encore à SBHM CONCEPT, toute reproduction,
            distribution ou modification de ce site sans l’autorisation écrite
            préalable de SBHM DIGITAL est interdite et pourra donner lieu à des
            poursuites judiciaires.
          </p>
        </section>

        <section>
          <h3>Collecte des données personnelles</h3>
          <p>
            SBHM DIGITAL collecte les données personnelles suivantes pour
            recontacter les clients :
          </p>
          <ul>
            <li>Nom et prénom</li>
            <li>Adresse e-mail</li>
            <li>Ville</li>
          </ul>
          <p>
            Conformément au Règlement Général sur la Protection des Données
            (RGPD), vous disposez d’un droit d’accès, de modification, de
            rectification et de suppression des données vous concernant. Pour
            exercer ces droits, veuillez nous contacter à l'adresse suivante :{" "}
            <a href="mailto:sbhm-concept@gmail.com">sbhm-concept@gmail.com</a>.
          </p>
        </section>

        <section>
          <h3>Politique de conservation des données</h3>
          <p>
            SBHM CONCEPT conserve vos données pour la durée nécessaire pour vous
            fournir ses services ou de vous fournir une assistance.
          </p>
          <p>
            Dans la mesure raisonnablement nécessaire ou requise pour satisfaire
            aux obligations légales ou réglementaires, régler des litiges,
            empêcher les fraudes et abus ou appliquer nos modalités et
            conditions, nous pouvons également conserver certaines de vos
            informations si nécessaire, même si nous n’en avons plus besoin pour
            vous fournir des services.
          </p>
        </section>

        <section>
          <h3>
            Droit d’accès, de rectification et de déréférencement de vos données
          </h3>
          <p>
            Conformément à la réglementation sur les données personnelles, les
            utilisateurs bénéficient des droits suivants :
          </p>
          <ul>
            <li>Droit d’accès</li>
            <li>Droit de rectification</li>
            <li>Droit à l’effacement</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit d'opposition</li>
            <li>Droit à la portabilité</li>
          </ul>
          <p>
            Pour exercer ces droits, merci de nous contacter à l'adresse
            suivante :<br />
            510 Chemin de la Rivière,
            <br />
            31660 Bessières, France.
            <br />
            Ou par email :{" "}
            <a href="mailto:sbhm-concept@gmail.com">sbhm-concept@gmail.com</a>.
          </p>
          <p>
            Toute demande doit être accompagnée d'une copie d'une pièce
            d'identité valide signée et indiquer l'adresse à laquelle nous
            pourrons vous répondre. Nous nous engageons à répondre dans un délai
            d'un mois suivant la réception de votre demande, ce délai pouvant
            être prolongé de deux mois si la demande est complexe ou si un grand
            nombre de demandes est reçu.
          </p>
        </section>

        <section>
          <h3>Responsabilités</h3>
          <p>
            La responsabilité de SBHM DIGITAL ne pourra être engagée en cas de
            défaillance, de panne, de difficulté ou d’interruption du
            fonctionnement qui empêcherait l’accès au site ou à l’une de ses
            fonctionnalités.
          </p>
          <p>
            L’utilisation de votre matériel de connexion au site est entièrement
            sous votre responsabilité. Vous devez prendre toutes les précautions
            nécessaires pour protéger votre équipement et vos données
            personnelles, notamment contre les attaques virales provenant
            d'Internet. Vous êtes également seul responsable des sites et des
            données que vous consultez.
          </p>
          <p>
            SBHM DIGITAL ne pourra être tenu responsable des poursuites
            judiciaires éventuelles à votre encontre, résultant :
          </p>
          <ul>
            <li>
              De l’utilisation du site ou de tout service accessible par
              Internet ;
            </li>
            <li>Du non-respect de ces mentions légales.</li>
          </ul>
          <p>
            L’éditeur décline toute responsabilité pour les dommages pouvant
            survenir à vous-même, à des tiers et/ou à votre équipement en raison
            de votre connexion ou de l’utilisation du site. Vous renoncez
            également à toute action à son encontre pour ces raisons.
          </p>
        </section>

        <section>
          <h3>Accès au site</h3>
          <p>
            L’accès et l'utilisation du site sont réservés à un usage
            strictement personnel. En utilisant ce site, vous vous engagez à ne
            pas exploiter les informations ou données qui y figurent à des fins
            commerciales, politiques, publicitaires ou pour toute forme de
            sollicitation commerciale, y compris l'envoi de courriers
            électroniques non sollicités.
          </p>
        </section>

        <section>
          <h3>Contenu du site</h3>
          <p>
            L'ensemble des marques, photographies, textes, commentaires,
            illustrations, images animées ou non, séquences vidéo, sons, ainsi
            que toutes les applications informatiques utilisées pour faire
            fonctionner ce site, sont protégés par les lois en vigueur en
            matière de propriété intellectuelle.
          </p>
          <p>
            Ces éléments sont la propriété exclusive de SBHM DIGITAL ou de ses
            partenaires. Toute reproduction, représentation, utilisation ou
            adaptation, sous quelque forme que ce soit, de tout ou partie de ces
            éléments, y compris les applications informatiques, sans
            l'autorisation écrite et préalable de SBHM DIGITAL, est formellement
            interdite.
          </p>
        </section>

        <section>
          <h3>Gestion du site</h3>
          <p>
            Pour assurer le bon fonctionnement du site, SBHM DIGITAL se réserve
            le droit de :
          </p>
          <ul>
            <li>
              Suspendre, interrompre ou limiter l'accès à tout ou partie du
              site.
            </li>
            <li>
              Réserver l'accès à certaines sections du site à un groupe
              déterminé d'utilisateurs.
            </li>
            <li>
              Supprimer toute information susceptible de perturber le
              fonctionnement du site ou de contrevenir aux lois nationales ou
              internationales, ou aux règles de la Nétiquette.
            </li>
            <li>Suspendre le site pour effectuer des mises à jour.</li>
          </ul>
        </section>

        <button
          aria-label="fermer les conditions d'utilisations"
          className="close-button"
          onClick={onClose}
        >
          Fermer
        </button>
      </div>
    </div>
  );
};

export default LegalModal;
